import { http } from "../http-common";

const FetchAllSubGrowerViewLog = (query) => {
  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("pageSize", query.size);
  if (query.status) {
    params.append("status", query.status);
  }
  if (query.keyword) {
    params.append("keyword", query.keyword);
  }
  return http.get(`/sub-grower-import/logs?importId=${query.id}&${params.toString()}`);
};

const downloadSubGrowerTemplate = (cropYear) => {
  return http.get(`/sub-grower-import/template/${cropYear}`);
};

const FetchSubGrowerLogDetail = (id) => {
  return http.get(`/sub-grower-import/log/${id}`);
};

const ImportSubGrowerService = {
  FetchAllSubGrowerViewLog,
  downloadSubGrowerTemplate,
  FetchSubGrowerLogDetail,
};

export default ImportSubGrowerService;
